import React from 'react';
import { FieldDefinition } from '../entityTypes';
import { TextField } from '@material-ui/core';
import { CurrencyField } from '../../form/CurrencyField';

interface Props {
  fieldDefinition: FieldDefinition;
  entity: any;
  formRef: any;
  formErrors: any;
  formControl: any;
}

export function EntityEditCurrencyField(props: Props) {
  const { fieldDefinition, entity, formRef, formErrors } = props;
  return (
    <TextField
      name={fieldDefinition.name}
      defaultValue={entity[fieldDefinition.name]}
      fullWidth
      required={fieldDefinition.editOptions.mandatory}
      label={fieldDefinition.label}
      variant="outlined"
      inputRef={formRef}
      error={formErrors[fieldDefinition.name] != null}
      helperText={formErrors[fieldDefinition.name]?.message}
      InputProps={{
        inputComponent: CurrencyField as any
      }}
    />
  );
}
